export default class SkipHireService {
    store = (route, data) => {
        return axios.post(route, data);
    };

    update = (route, data) => {
        return axios.post(route, data);
    };
}
